var React = require('react');

function Star (props) {
    return React.createElement("svg",props,React.createElement("path",{"fill":"current","d":"M12 .25a.75.75 0 01.673.418l3.058 6.197 6.839.994a.75.75 0 01.415 \n  1.279l-4.948 4.823 1.168 6.811a.75.75 0 01-1.088.791L12 18.347l-6.117 3.216a.75.75 0 \n  01-1.088-.79l1.168-6.812-4.948-4.823a.75.75 0 01.416-1.28l6.838-.993L11.328.668A.75.75 \n  0 0112 .25zm0 2.445L9.44 7.882a.75.75 0 01-.565.41l-5.725.832 4.143 4.038a.75.75 0 \n  01.215.664l-.978 5.702 5.121-2.692a.75.75 0 01.698 0l5.12 2.692-.977-5.702a.75.75 0 \n  01.215-.664l4.143-4.038-5.725-.831a.75.75 0 01-.565-.41L12 2.694z"}));
}

Star.defaultProps = {"width":"24","height":"24","viewBox":"0 0 24 24"};

module.exports = Star;

Star.default = Star;
